import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  SCREEN_ID_RENTER_PROFILE_SUBMITTED,
} from 'client/constants/screenIds';

import branch from 'client/core/branch';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import SrLink from 'client/components/SrLink/SrLink';
import SrAgentLeadHighFiveModal from 'client/components/SrAgentLeadHighFiveModal';

@withTransitionHook
@withScrollToTop
@withScreenId(SCREEN_ID_RENTER_PROFILE_SUBMITTED)
@branch({
  appUrl: ['env', 'APP_URL'],
})
class RenterProfileSubmittedPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Renter Profile Submitted | Sunroom',
  })

  static propTypes = {
    appUrl: PropTypes.string.isRequired,
  }

  render() {
    const { appUrl } = this.props;
    return (
      <div className='modal success confirm pay-app-fee'>
        <div className='contentContainer'>
          <div className='highFiveAnimationContainer'>
            <SrAgentLeadHighFiveModal appUrl={appUrl} />
          </div>
          <div className='textContainer'>
            <span className='headline'>Application Completed</span>
            <span className='explainer'>
              {
                'Woohoo! We\'re reviewing your application. ' +
                'Use this application for any rental in Texas!'
              }
            </span>
          </div>

          <SrLink
            className='button yellow'
            to='/profile'
          >
            done
          </SrLink>
        </div>
      </div>
    );
  }
}

RenterProfileSubmittedPage.displayName = 'RenterProfileSubmittedPage';

export default RenterProfileSubmittedPage;
